import {HttpErrorResponse, HttpStatusCode} from '@angular/common/http';
import {EnumLikeType, Utils} from '../common-utils';

export type SymfonyKnownError = HttpErrorResponse & {
  error: {
    detail: string;
  };
};

export module HttpUtils {

  /**
   * Check the type and status of a Symfony error.
   * @see SymfonyKnownError
   */
  export function isSymfonyKnownError<T>(
    error: HttpErrorResponse,
    knownErrorType: EnumLikeType<T>,
    expectedStatusCode: Array<HttpStatusCode> = [HttpStatusCode.BadRequest],
  ): error is SymfonyKnownError {
    return (expectedStatusCode as Array<number>).includes(error.status) &&
      Utils.isObject(error.error) &&
      'detail' in error.error &&
      Utils.enumValueExists(error.error.detail as string ?? '', knownErrorType);
  }

  /**
   * Get the detailed message of a Symfony known error.
   */
  export function getSymfonyKnownErrorDetailMessage(error: SymfonyKnownError): string {
    if (Utils.isObject(error.error) && 'detail' in error.error) {
      return error.error.detail as string;
    }
    return '';
  }
}
